import {
  PROPOSAL_STEP,
  PROPOSAL_FORM_STATUS,
  PROPOSAL_REVIEWER,
  PROPOSAL_REVIEW_CRITERIA,
  APPUSER_REVIEWER_LIST,
  PROPOSAL_FORM_LIST,
  PROPOSAL_REVIEWER_LIST,
  PROPOSAL_RESPONSE_LIST,
  PROPOSAL_LIST,
  PROPOSAL_URL_MODAL,
  PROPOSAL_FORM_EDIT_MODAL,
  PROPOSAL_ADD_REVIEWER_MODAL,
  CHANGE_REVIEWER_MODAL,
  PROPOSAL_REPONSE_MODAL,
  PROPOSAL_RANKING,
  PROPOSAL_TICKET_SEND_MODAL,
  MANAGE_PROPOSAL_MODAL,
  PROPOSAL_EDIT,
  MANAGE_REVIEWER_PWD_MODAL,
  PROPOSAL_CONFIRM_MODAL,
  PROPOSAL_ALL_USERS,
  PROPOSAL__UNREVIEWED_RESPONSE_LIST,
  PROPOSAL_REVIEWED_RESPONSE_LIST,
  PROPOSAL_SHORTLISTED_RESPONSE_LIST,
  PROPOSAL_REJECTED_RESPONSE_LIST,
  SHOW_PROPOSAL_LOADER,
  RATINGS_STORE,
  PROPOSAL_ALL_RESPONSE_LIST,
  UPDATED_PROPOSAL_LOADER,
  FILTER_PROPOSAL,
  SORTBY_FILTER_PROPOSAL,
} from "ProposalAction";

export function ProposalStep(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_STEP:
      return action.payload;
    default:
      return state;
  }
}

export function checkProposalForm(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_FORM_STATUS:
      return action.payload;
    default:
      return state;
  }
}

export function proposalReviewerStatus(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_REVIEWER:
      return action.payload;
    default:
      return state;
  }
}

export function proposalReviewCriteriaStatus(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_REVIEW_CRITERIA:
      return action.payload;
    default:
      return state;
  }
}

export function appUserreviewerList(state = {}, action) {
  switch (action.type) {
    case APPUSER_REVIEWER_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function proposalFormList(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_FORM_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function reviewerList(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_REVIEWER_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function responseList(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_RESPONSE_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function proposalList(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function showProposalUrlModal(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_URL_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function editProposalModal(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_FORM_EDIT_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function addReviewerModal(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_ADD_REVIEWER_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function showChangeReviewer(state = {}, action) {
  switch (action.type) {
    case CHANGE_REVIEWER_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function showProposalResponse(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_REPONSE_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function proposalRanking(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_RANKING:
      return action.payload;
    default:
      return state;
  }
}

export function showProposalTicketModal(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_TICKET_SEND_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function showManageProposalModal(state = {}, action) {
  switch (action.type) {
    case MANAGE_PROPOSAL_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function updateProposal(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_EDIT:
      return action.payload;
    default:
      return state;
  }
}

export function showChangePasswordReviewer(state = {}, action) {
  switch (action.type) {
    case MANAGE_REVIEWER_PWD_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function proposalConfirmModal(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_CONFIRM_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function proposalAttendeeList(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_ALL_USERS:
      return action.payload;
    default:
      return state;
  }
}

export function unreviewedproposalList(state = {}, action) {
  switch (action.type) {
    case PROPOSAL__UNREVIEWED_RESPONSE_LIST:
      return action.payload;
    default:
      return state;
  }
}
export function reviewedproposalList(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_REVIEWED_RESPONSE_LIST:
      return action.payload;
    default:
      return state;
  }
}
export function shortlistedproposalList(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_SHORTLISTED_RESPONSE_LIST:
      return action.payload;
    default:
      return state;
  }
}
export function rejectedproposalList(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_REJECTED_RESPONSE_LIST:
      return action.payload;
    default:
      return state;
  }
}
export function showproposalLoader(state = {}, action) {
  switch (action.type) {
    case SHOW_PROPOSAL_LOADER:
      return action.payload;
    default:
      return state;
  }
}
export function ratingStore(state = {}, action) {
  switch (action.type) {
    case RATINGS_STORE:
      return action.payload;
    default:
      return state;
  }
}
export function allresponseProposal(state = {}, action) {
  switch (action.type) {
    case PROPOSAL_ALL_RESPONSE_LIST:
      return action.payload;
    default:
      return state;
  }
}
export function updatedProposalLoader(state = {}, action) {
  switch (action.type) {
    case UPDATED_PROPOSAL_LOADER:
      return action.payload;
    default:
      return state;
  }
}
export function filterbyProposal(state = {}, action) {
  switch (action.type) {
    case FILTER_PROPOSAL:
      return action.payload;
    default:
      return state;
  }
}
export function sortbyFilter(state = {}, action) {
  switch (action.type) {
    case SORTBY_FILTER_PROPOSAL:
      return action.payload;
    default:
      return state;
  }
}

